export default __webpack_public_path__ + "static/media/collage.5528d3bf.jpg";